// Misc Vuex

import state from './miscStates.js'
import * as getters from './miscGetters.js'
import * as mutations from './miscMutations.js'
import * as actions from './miscActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
